/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';

class ShortNameField extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      label: props.label || 'Title',
      shortName: props.shortName || '',
      shortNameError: props.shortName && props.shortName.length < 1,
      edited: props.inputEdited,
      overlayer: true
    };
    this.handleNameChange = this.handleNameChange.bind(this);
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      return this.input.focus();
    }
    return null;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.shortName !== '' && this.state.shortName === '') {
      this.setState({ shortName: nextProps.shortName });
    }

    if (
      nextProps.shortName !== this.state.shortName &&
      this.input !== document.activeElement
    ) {
      this.setState({ shortName: nextProps.shortName });
    }
  }

  componentDidUpdate() {
    if (
      this.state.shortNameError &&
      (this.state.edited || this.props.inputEdited)
    ) {
      this.validationErr.hidden = false;
      this.validationErr.innerHTML = `<span>${this.state.label} should not be blank</span>`;
    } else {
      this.validationErr.hidden = true;
    }
  }

  handleEdit(event) {
    event.preventDefault();
    const { target } = event;
    target.focus();
    // scroll to end of textarea - currently not working due to parent behavior I think
    // const { length } = target.value;
    // target.setSelectionRange(length, length);
  }

  handleNameChange(event) {
    event.preventDefault();
    const shortName = event.target.value;
    const shortNameError = shortName && shortName.length < 1;
    {
      this.setState({ shortName, shortNameError, edited: true });
    }
  }

  handleOnBlur = (e) => {
    // if user changes name to nothing
    if (e.target.value == '') {
      // reset to stored value
      e.target.value = this.props.shortName;
      this.setState({ shortName: this.props.shortName, edited: false });
    } else {
      // if valid update name
      this.props.onNameChange({
        short_name: e.target.value
      });
    }

    if (this.props.textAreaRef) {
      this.props.textAreaRef.current.scrollTo(0, 0);
    }
    this.setState({ overlayer: true }, () => {
      if (this.props.unFocus) {
        this.props.unFocus();
      }
    });
  };

  handleOverlayerClick = () => {
    this.setState({ overlayer: false }, () =>
      this.props.textAreaRef.current.focus()
    );
  };

  renderTextArea = () => {
    const {
      allowEdit,
      fieldName,
      onKeyUp,
      isValid,
      autoFocus,
      storyRow,
      textAreaRef,
      rowHeight,
      placeholder,
      extraClasses
    } = this.props;
    const { shortName, overlayer } = this.state;

    return storyRow ? (
      <div className="name-overlayer-container">
        {/*  this div overlayer is present such that a user can effectively
        drag and drop while clicking over the textarea element.
    */}
        <div
          className="row-text-overlayer"
          // style={{ display: overlayer ? 'block' : 'none' }}
          onMouseUp={this.handleOverlayerClick}
        />

        <label className="vertically-centered-story">
          <textarea
            id="short-name"
            type="text"
            className={`form-control ${
              !isValid && !shortName ? 'error-field' : ''
            } ${extraClasses}`}
            name={fieldName || 'short_name'}
            readOnly={!allowEdit}
            disabled={!allowEdit}
            value={shortName || ''}
            placeholder={!isValid && !shortName ? "Can't be blank" : ''}
            style={{ height: `${rowHeight - 10}px` }}
            onMouseUp={this.handleEdit}
            onChange={this.handleNameChange}
            onBlur={this.handleOnBlur}
            onKeyUp={onKeyUp}
            spellCheck={false}
            ref={textAreaRef}
          />
        </label>
      </div>
    ) : (
      <input
        autoFocus={autoFocus}
        id="short-name"
        type="text"
        className={`form-control ${
          !isValid && !shortName ? 'error-field' : ''
        } ${extraClasses}`}
        name={fieldName || 'short_name'}
        readOnly={!allowEdit}
        disabled={!allowEdit}
        value={shortName || ''}
        placeholder={
          !isValid && !shortName ? "Can't be blank" : placeholder || ''
        }
        onChange={this.handleNameChange}
        ref={(input) => {
          this.input = input;
        }}
        onBlur={this.handleOnBlur}
        onKeyUp={onKeyUp}
      />
    );
  };

  render() {
    return (
      <>
        {this.renderTextArea()}
        <div
          className="btn-danger"
          ref={(validationErr) => {
            this.validationErr = validationErr;
          }}
        />
      </>
    );
  }
}

ShortNameField.propTypes = {
  shortName: PropTypes.string.isRequired,
  onNameChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  inputEdited: PropTypes.bool,
  allowEdit: PropTypes.bool,
  autoFocus: PropTypes.bool,
  onKeyUp: PropTypes.func,
  isValid: PropTypes.bool,
  extraClasses: PropTypes.string
};

ShortNameField.defaultProps = {
  isValid: true,
  placeholder: '',
  extraClasses: ''
};

export default React.forwardRef((props, ref) => (
  <ShortNameField textAreaRef={ref} {...props} />
));
